import { AiOutlineProduct } from 'react-icons/ai';
import { BsBoxSeam, BsPersonVcard } from 'react-icons/bs';
import { GiShoppingCart } from 'react-icons/gi';
import { HiOutlineDocumentReport } from 'react-icons/hi';
import { IoSettingsOutline } from 'react-icons/io5';
import { MdHelpOutline, MdPayments } from 'react-icons/md';
import { tShared } from '../i18n';
import { AppInfo } from '../ui/nav/nav-bar.types';

// Single source of truth for the app launcher tiles and the NavBar drawer's
// Applications section. PERMISSION_GATED_APPS are filtered per user through
// authorizeAppOpen; DEFAULT_APPS are available to every signed-in user
// regardless of permissions, so they must never be sent to the authorizer.
export const PERMISSION_GATED_APPS: AppInfo[] = [
  {
    name: 'Reports',
    url: 'reports',
    icon: HiOutlineDocumentReport,
    color: 'purple',
  },
  { name: 'Products', url: 'products', icon: BsBoxSeam, color: 'blue' },
  {
    name: 'Inventory',
    url: 'inventory',
    icon: AiOutlineProduct,
    color: 'teal',
  },
  {
    name: 'Purchases',
    url: 'purchase-orders',
    icon: GiShoppingCart,
    color: 'orange',
  },
  { name: 'Clients', url: 'clients', icon: BsPersonVcard, color: 'pink' },
  { name: 'Billing', url: 'billing', icon: MdPayments, color: 'green' },
  { name: 'Settings', url: 'settings', icon: IoSettingsOutline, color: 'gray' },
];

export const DEFAULT_APPS: AppInfo[] = [
  { name: 'Help', url: 'help', icon: MdHelpOutline, color: 'cyan' },
];

// App names stay English (they are data); render them with t(app.name). These
// literal keys keep the names in the i18n extraction.
export const APP_NAME_KEYS = [
  tShared('Reports'),
  tShared('Products'),
  tShared('Inventory'),
  tShared('Purchases'),
  tShared('Clients'),
  tShared('Billing'),
  tShared('Settings'),
  tShared('Help'),
];

// Appends the always-available apps to a permission-filtered list.
export const withDefaultApps = (apps: AppInfo[]): AppInfo[] => [
  ...apps,
  ...DEFAULT_APPS,
];
